document.addEventListener('click', function (e) {
    const increaseBtn = e.target.closest('.cart_incre');
    const decreaseBtn = e.target.closest('.cart_decre');
    const removeBtn = e.target.closest('.cart-product-item-close-btn');

    if (increaseBtn || decreaseBtn || removeBtn) {
        e.preventDefault();
        e.stopPropagation();

        const productArea = document.querySelector('.product-content-area');
        const overlay = productArea?.querySelector('.cart-item-overlay');
        if (overlay) overlay.style.display = 'flex';

        const button = increaseBtn || decreaseBtn || removeBtn;

        if (increaseBtn) {
            itemPlus(increaseBtn);
        } else if (decreaseBtn) {
            itemMinus(decreaseBtn);
        } else if (removeBtn) {
            itemRemoved(removeBtn);
        }
    }
});

function itemPlus(button) {
    const input = button.parentElement.querySelector('.cart_qty_total');
    let qty = parseInt(input.value || 0) + 1;
    input.value = qty;

    const minusButton = button.parentElement.querySelector('.cart_decre');
    if (minusButton && qty > 1) {
        minusButton.disabled = false;
    }

    updateCartQuantity(button.dataset.id, qty);
}

function itemMinus(button) {
    const input = button.parentElement.querySelector('.cart_qty_total');
    let qty = parseInt(input.value || 0) - 1;

    if (qty <= 1) {
        button.disabled = true;
        qty = 1;
    } else {
        button.disabled = false;
    }

    input.value = qty;
    updateCartQuantity(button.dataset.id, qty);
}

function itemRemoved(button) {
    updateCartQuantity(button.dataset.id, 0);
}

function updateCartQuantity(id, quantity) {
    const productArea = document.querySelector('.product-content-area');
    const overlay = productArea?.querySelector('.cart-item-overlay');

    fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id.toString(), quantity })
    })
    .then(res => res.json())
    .then(data => {
        if (data.status && data.status !== 200) {
            displayErrorMessage(data.message || 'Something went wrong. Please try again.');
        } else {
            cart_item_update();
        }
    })
    .catch(err => {
        displayErrorMessage('There was an error updating the cart. Please try again.');
    })
    .finally(() => {
        if (overlay) overlay.style.display = 'none';
    });
}

function displayErrorMessage(message) {
    const errorDiv = document.querySelector('.cart-quantity-error');
    if (errorDiv) {
        errorDiv.innerHTML = `<p>${message}</p>`;
        errorDiv.style.display = 'block';

        setTimeout(() => {
            errorDiv.style.display = 'none';
            cart_item_update();
        }, 2000);
    }
}



// Old Code for cart drawer

// // cart item increase 
// function itemPlus(e, el) {
//     var id = $(el).data('id');
//     var qty = $(el).prev().val();
//     qty = parseInt(qty) + 1;
//     $(el).prev().val(qty);
//     $.ajax({
//         type : "POST",
//         url:'/cart/change.js', 
//         data: {
//             id: parseFloat(id),
//             quantity: qty
//         },
//         dataType:'json',
//         success:function(data) {
//             cart_item_update();
            
//             // console.log('Increased');
//         },
//         error:function(err) {
//             console.log('Error')
//         }
//     })
// }
// // cart item decrease
// function itemMinus(e, el) {
//     var id = $(el).data('id');
//     var qty = $(el).next().val();
//     qty = parseInt(qty) - 1;
//     if(qty >= 1) {
//         $(el).next().val(qty);
//         $.ajax({
//             type : "POST",
//             url:'/cart/change.js',
//             data: {
//                 id: parseFloat(id),
//                 quantity: qty
//             },
//             dataType:'json',
//             success:function(data) {
//                 cart_item_update();
                
//             },
//             error:function(err) {
//                 console.log('Error')
//             }
//         })
//     }
// }
// // cart item decrease
// function itemRemoved(e, el) {
//     var id = $(el).data('id');
//     $.ajax({
//         type : "POST",
//         url:'/cart/change.js',
//         data: {
//             id: parseFloat(id),
//             quantity: 0
//         },
//         dataType:'json',
//         success:function(data) {
//             cart_item_update();
//         },
//         error:function(err) {
//             console.log('Error')
//         }
//     })
// }